import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useSetAgentId } from '~/features/agents/hooks/useSetAgentId'
import {
  EAgentKeys,
  TAgent,
  TCreateAgentPayload,
} from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'

type TCreateAgentVariables = {
  headers?: Record<string, string>
  payload: TCreateAgentPayload
}

const useCreateAgent = () => {
  const queryClient = useQueryClient()
  const setAgentId = useSetAgentId()

  const createAgent = ({ headers, payload }: TCreateAgentVariables) =>
    HttpService.post<TAgent>(
      { headers, path: EServerPath.agents, payload },
      EHttpService.agent,
    )

  return useMutation({
    mutationKey: queryKeys.createAgent(),
    mutationFn: createAgent,
    onSuccess: (response, { headers, payload }) => {
      if (!headers) {
        setAgentId({ agentId: response?.data?.id })
      }

      queryClient.invalidateQueries({
        queryKey: queryKeys.agents({}),
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.agentsByOrganization(
          payload[EAgentKeys.orgId] || '',
        ),
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: queryKeys.adminAgents({}),
        exact: false,
      })
    },
  })
}

export default useCreateAgent
